export const getInitials = (name) =>
  name ? name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "?";

export const SUPERVISOR_ROLES = ["owner", "administrator", "developer", "supervisor"];
export const ADMIN_ROLES = ["owner", "administrator"];
// Owner-only operations: tenant user management (list/edit/delete users
// in Admin → Users & Roles). Backend endpoints under /api/auth/users
// are gated on require_owner. Mirrored on the frontend so non-owners
// don't see the empty Users tab when their fetchUsers() 403s.
export const OWNER_ROLES = ["owner"];
